import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'msc-organize-knowledge',
    templateUrl: './knowledge.component.html'
})
export class OrganizeKnowledgeComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}
}
